import type { ImpersonationMerchantRole } from "@unbox/api";

export const ROLE_DESCRIPTIONS: [ImpersonationMerchantRole, string][] = [
  ["workspace_admin", "Full control of the workspace: settings, team and every merchant in it."],
  ["merchant_admin", "Manage the merchants they are given, including merchant settings and team."],
  ["user", "Day-to-day access to the merchants they are given. No settings or team."],
];

/** Production refuses to create scenarios, so the modal offers them everywhere else. */
export const CAN_CREATE_SCENARIOS = import.meta.env.VITE_STAGE !== "prod";

// Outside production the users are seeded scenarios, so the switcher talks about loading them.
// Production switches into real accounts and keeps the switcher's original wording.
export const SWITCHER_COPY = CAN_CREATE_SCENARIOS
  ? {
      open: "Load different Scenario",
      title: "Scenarios",
      description:
        "Load a scenario to see the app exactly as that user does. Open a row to check what they have access to first.",
      start: (firstName: string) => `Load ${firstName} scenario`,
      end: "End Scenario",
      active: (name: string) => `Scenario: ${name}`,
      listLabel: "Preconfigured scenarios",
    }
  : {
      open: "Impersonate user",
      title: "All Users",
      description:
        "See the app exactly as a user does. Open a row to check what they have access to before you switch.",
      start: (firstName: string) => `Impersonate ${firstName}`,
      end: "End Impersonation",
      active: (name: string) => `Impersonating ${name}`,
      listLabel: null,
    };

export const STORAGE_KEYS = { favourites: "impersonate:favourites" } as const;

export const loadList = <T>(key: string): T[] => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(key) ?? "");
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
};

export const saveList = <T>(key: string, value: T[]): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Favourites are a convenience; a browser that refuses storage just forgets them.
  }
};
